import API from "./";

export const getAllStaff = () => API.get("/staffs/");

export const createStaff = (payload) => API.post("/staffs/", payload);

export const updateStaff = (id, payload) => API.put(`/staffs/${id}/`, payload);
